import { useEffect } from 'react';
import { useI18n } from '../context/I18nContext';

const SEO_CONFIG = {
    es: {
        title: 'MealPlanner - Planifica tus comidas semanales',
        description: 'Genera menús semanales automáticamente, gestiona tus recetas favoritas y comparte con tu familia. Planifica tu semana de comidas sin estrés.',
        keywords: 'planificador de comidas, menú semanal, recetas, meal planner, planificación de menús',
        ogImage: 'https://mealplanner.es/images/og-image-es.png',
        locale: 'es_ES',
    },
    en: {
        title: 'MealPlanner - Plan your weekly meals',
        description: 'Generate weekly menus automatically, manage your favorite recipes and share with your family. Plan your week stress-free.',
        keywords: 'meal planner, weekly menu, recipes, meal planning, food planning',
        ogImage: 'https://mealplanner.es/images/og-image-en.png',
        locale: 'en_GB',
    },
};

export default function SEOHead() {
    const { language } = useI18n();
    const config = SEO_CONFIG[language] || SEO_CONFIG.es;

    useEffect(() => {
        // Update document title
        document.title = config.title;

        // Update meta tags
        const updateMetaTag = (property, content, isProperty = false) => {
            const attribute = isProperty ? 'property' : 'name';
            let meta = document.querySelector(`meta[${attribute}="${property}"]`);
            if (meta) {
                meta.setAttribute('content', content);
            }
        };

        // Update basic meta tags
        updateMetaTag('description', config.description);
        updateMetaTag('keywords', config.keywords);
        updateMetaTag('title', config.title);

        // Update Open Graph tags
        updateMetaTag('og:title', config.title, true);
        updateMetaTag('og:description', config.description, true);
        updateMetaTag('og:image', config.ogImage, true);
        updateMetaTag('og:locale', config.locale, true);

        // Update Twitter tags
        updateMetaTag('twitter:title', config.title, true);
        updateMetaTag('twitter:description', config.description, true);
        updateMetaTag('twitter:image', config.ogImage, true);

        // Update html lang attribute
        document.documentElement.lang = language;
    }, [language, config]);

    return null; // This component doesn't render anything
}
